export default __webpack_public_path__ + "static/media/luna.21a807b9.jpg";